let header = document.querySelector(".header")
let headerBtn = document.querySelector(".header__innerMenu")
let menuBtns = document.querySelector(".header__innerNavInner")
let orsplogo = document.querySelector(".header__innerNavLogo a")

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    if (header.classList.contains("is-on")) {
        scrollable(true)
    } else {
        scrollable(false)
    }
})

menuBtns.childNodes.forEach((btn) => {
    btn.addEventListener("click", () => {
        header.classList.remove("is-on");
        scrollable(false)
    })
})

orsplogo.addEventListener("click", () => {
    header.classList.remove("is-on");
    scrollable(false)
})

function scrollable(boo) {
    if (boo) {
        document.addEventListener('touchmove', disableScrollable, {
            passive: false
        });
        document.addEventListener('mousewheel', disableScrollable, {
            passive: false
        });
        window.globalLocoStop()
    } else {
        document.removeEventListener('touchmove', disableScrollable, {
            passive: false
        });
        document.removeEventListener('mousewheel', disableScrollable, {
            passive: false
        });
        window.globalLocoStart()
    }
}

function disableScrollable(event) {
    event.preventDefault();
}